import {
  CategoryScale,
  Chart as ChartJS,
  LinearScale,
  LineElement,
  PointElement
} from 'chart.js';
import Annotation from 'chartjs-plugin-annotation';
import PropTypes from 'prop-types';
import React from 'react';
import { Line } from 'react-chartjs-2';
import { getColor } from '../../helpers/utils';
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Annotation
);

const ChartPlaceholder = ({ text = 'Grafico non disponibile' }) => {
  const data = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    datasets: [
      {
        type: 'line',
        label: 'Dataset 1',
        borderColor: getColor('primary'),
        borderWidth: 2,
        fill: false,
        data: [55, 80, 60, 22, 50, 40, 90],
        tension: 0.3
      }
    ]
  };

  const options = {
    plugins: {
      legend: {
        labels: {
          color: getColor('gray-500')
        }
      },
      annotation: {
        annotations: {
          box1: {
            type: 'box',
            xMin: 0,
            xMax: 6,
            yMin: 0,
            yMax: 100,
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            borderColor: 'rgba(0, 0, 0, 0)'
          },
          label1: {
            type: 'label',
            xMin: 0,
            xMax: 6,
            yMin: 50,
            yMax: 50,
            content: text,
            font: {
              size: 18,
              weight: 'bold'
            },
            color: getColor('gray-500'),
            textAlign: 'center'
          }
        }
      }
    },
    scales: {
      x: {
        ticks: {
          color: getColor('gray-500')
        },
        grid: {
          color: getColor('gray-300'),
          drawBorder: false
        }
      },
      y: {
        ticks: {
          color: getColor('gray-500')
        },
        grid: {
          color: getColor('gray-300'),
          drawBorder: false
        }
      }
    },
    maintainAspectRatio: false
  };

  return <Line data={data} options={options} />;
};

ChartPlaceholder.propTypes = {
  text: PropTypes.string
};

export default ChartPlaceholder;
